<script lang="ts">
	//Helpers
	import { get_local_ip, real_id } from '../../../../../helpers/interface_helpers';
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Services
	import { format } from '../../../../../services/i18n';
	import { localReq, postReq } from '../../../../../services/http';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Radio, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;

	const btnTypes = ['onebutton', 'openclose'];

	const options = [
		$format('option_roller_input_one_button', {
			default:
				'One button - Every time Button 1 is pressed the roller will go in the next sequence step (Open/Stop/Close/Stop/...).',
		}),
		$format('option_roller_open_close_buttons', {
			default: 'Open & Close Buttons - Use separate buttons for OPEN & CLOSE.',
		}),
	];

	let localIp = get_local_ip(id);

	let index = btnTypes.indexOf(
		$settingsStore[device.category + 's'][device.channel].input_mode,
	);
	let cacheIndex = index;

	let loading = false;

	const setMode = (val) => {
		index = val;
	};

	const sentRequest = async () => {
		if (cacheIndex !== index) {
			let res;
			loading = true;
			if (localIp) {
				res = await localReq(
					device,
					`${localIp}/settings/${device.category}/${device.channel}`,
					'post',
					{
						input_mode: btnTypes[index],
					},
				);
			} else {
				res = await postReq(`/device/relay/roller/settings/input_mode`, {
					id: id,
					roller_id: device.channel,
					input_mode: btnTypes[index],
				});
			}

			if (res.isok) {
				settings[device.category + 's'][device.channel].input_mode = btnTypes[index];
				devices_settings.update_devices_settings(device.id, settings);
				toast.open({
					type: 'success',
					title:
						$format('btn_type_scc_toast', {
							values: { type_value: btnTypes[index] },
						}) || `Button type was changed to ${formatSnakeCaseToTitle(btnTypes[index])}.`,
				});
				cacheIndex = index;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				index = cacheIndex;
			}
			loading = false;
		}
	};
</script>

{#each btnTypes as _type, i}
	<Radio
		size="m"
		selected={index.toString()}
		value={i.toString()}
		on:click={() => setMode(i)}
		id="radio-jro4wnk">{options[i]}</Radio
	>
{/each}
<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}
	>{$format('button_save')}</Button
>
